<div class="flexColumnContainer">
  <div #breadCrumbsAndButtonsContainer id="breadCrumbsAndButtonsContainer"
       class="flexRowContainer justifyContentSpaceBetween">
    <div #breadcrumbEl class="breadcrumbContainer flexRowContainer">
      <span class="breadcrumb parent" (click)="backToCaseOverviewWithDialog()"
            (keydown.enter)="backToCaseOverviewWithDialog()">
        {{ 'previewFormMetadata.breadcrumb.cases' | translate }}
      </span>
      <mat-icon class="material-symbols-outlined breadcrumbIcon">chevron_right</mat-icon>
      <span class="breadcrumb parent" (click)="backToCaseDetailWithDialog()"
            (keydown.enter)="backToCaseDetailWithDialog()">
        {{ documentHal?.caseName }}
      </span>
      <mat-icon class="material-symbols-outlined breadcrumbIcon">chevron_right</mat-icon>
      <span id="documentTitle" class="breadcrumb current">
        {{ documentHal?.title }}
      </span>
    </div>
    <div id="buttonsContainer" class="flexRowContainer">
      @if (!isButtonHidden('renderPreview')) {
        <button mat-button (click)="renderPreview()" (keydown.enter)="renderPreview()"
                [disabled]="!documentHal?.renderPreviewEnabled">
          <mat-icon class="material-symbols-outlined">preview</mat-icon>
          <span class="label-medium">
          {{ 'previewFormMetadata.renderPreview' | translate }}
        </span>
        </button>
      }
      @if (!isButtonHidden('save')) {
        <button mat-button (click)="formActionsHelperService.saveFormProgress(documentHal)"
                [disabled]="!documentHal?.saveProgressEnabled"
                (keydown.enter)="formActionsHelperService.saveFormProgress(documentHal)">
          <mat-icon class="material-symbols-outlined">save</mat-icon>
          <span class="label-medium">
          {{ 'previewFormMetadata.save' | translate }}
        </span>
        </button>
      }
      @if (hiddenButtons.size > 0) {
        <button mat-icon-button [matMenuTriggerFor]="overflowMenu">
          <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
        </button>
        <mat-menu #overflowMenu="matMenu">
          @for (btn of hiddenMenuButtons; track btn.key) {
            <button mat-menu-item (click)="btn.action()" [disabled]="btn.disabled()">
              @if (btn.icon) {
                <mat-icon class="material-symbols-outlined">{{ btn.icon }}</mat-icon>
              }
              {{ btn.labelKey | translate }}
            </button>
          }
        </mat-menu>
      }
      <button #primaryButton mat-flat-button (click)="formActionsHelperService.completeDataCapturing(documentHal)"
              [disabled]="!documentHal?.completeDataCapturingEnabled"
              (keydown.enter)="formActionsHelperService.completeDataCapturing(documentHal)">
        <mat-icon class="material-symbols-outlined">task</mat-icon>
        <span class="label-medium">
        {{ 'previewFormMetadata.completeDataCapturing' | translate }}
      </span>
      </button>
    </div>
  </div>
  <!-- Hidden measurement container -->
  <div class="overflowMeasureContainer" aria-hidden="true">
    @for (btn of overflowButtons; track btn.key) {
      @if (btn.visible()) {
        <button #measureButton [attr.data-key]="btn.key" mat-button>
          @if (btn.icon) {
            <mat-icon class="material-symbols-outlined">{{ btn.icon }}</mat-icon>
          }
          <span>{{ btn.labelKey | translate }}</span>
        </button>
      }
    }
  </div>
  <div id="descriptionContainer" [ngClass]="{ 'hidden': !documentHal?.description }">
    <span class="body-medium">{{ 'previewFormMetadata.description' | translate }}: {{ documentHal?.description }}</span>
  </div>
  <div id="tagContainer" class="flexRowContainer">
    <span class="documentTagRemake"
          [ngClass]="documentHal?.state?.toLowerCase()">{{ 'previewPdfMetadata.states.' + documentHal?.state?.toLowerCase() | translate }}
    </span>
  </div>
</div>
